import React from 'react';

const COLORS = ['#7C3AED','#2D5CF6','#1F8A5B','#E08C00','#C2452E','#1C71B8','#9333EA','#D6409F'];

function colorForName(name: string) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return COLORS[Math.abs(h) % COLORS.length];
}

interface AvatarProps {
  name?: string;
  src?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

export default function Avatar({ name = '?', src, size, color, className = '', style }: AvatarProps) {
  const initials = name.trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase();
  const bg = color ?? colorForName(name);
  const cls = ['t-avatar', size && `t-avatar--${size}`, className].filter(Boolean).join(' ');

  if (src) {
    return <img className={cls} src={src} alt={name} style={{ objectFit: 'cover', ...style }} />;
  }
  return (
    <span className={cls} style={{ background: bg, color: '#fff', borderColor: 'transparent', ...style }}>
      {initials || '?'}
    </span>
  );
}
